import {useFormContext} from 'react-hook-form';
import {IAnswer, QUESTION_TYPES} from '../../types';
import {FC} from 'react';

const QuestionTypeSelect: FC = () => {
  const {register, getValues, setValue} = useFormContext();

  const handleChangeQuestionType = () => {
    const answers = getValues('Answers');
    const editCorrectAnswer = answers?.map((answer: IAnswer) => ({
      ...answer,
      IsCorrect: false
    }));
    setValue('Answers', editCorrectAnswer, {shouldValidate: true, shouldDirty: true});
  };

  return (
    <div>
      <div className="flex justify-between">
        <p className="mb-[10px] text-base text-black font-medium">Тип вопроса</p>
        <span className="text-red text-base font-bold">*</span>
      </div>
      <select
        defaultValue={QUESTION_TYPES.MULTIPLE}
        {...register('Type', {required: true, onChange: handleChangeQuestionType})}
        className="w-full rounded-md shadow-custom mb-5 border-[#DFE4EA] focus:border-[#DFE4EA]"
      >
        <option value={QUESTION_TYPES.MULTIPLE}>Множественный выбор</option>
        <option value={QUESTION_TYPES.SINGLE}>Единичный выбор</option>
      </select>
    </div>
  );
};
export default QuestionTypeSelect;
